export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8270.74a7b214.jpg";